import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as ArrowBackIosNewIcon } from './icons/arrow_back_ios_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg';
import { ReactComponent as ArrowForwardIosIcon } from './icons/arrow_forward_ios_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg';

const ProductMediaSidebar = ({ isOpen, toggleSidebar, productMedia }) => {
  // Stato per il carosello
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);

  // Costruisci l'array dei media disponibili
  const mediaItems = [];
  if (productMedia) {
    if (productMedia.urlImage) {
      mediaItems.push({ type: 'image', content: productMedia.urlImage });
    }
    if (productMedia.urlVideo) {
      mediaItems.push({ type: 'video', content: productMedia.urlVideo });
    }
    if (productMedia.url3Dviewer) {
      // Assicura che l'URL sia sempre HTTPS per evitare errori di "Mixed Content"
      const secureUrl = productMedia.url3Dviewer.replace(/^http:\/\//i, 'https://');
      mediaItems.push({ type: '3d', content: secureUrl });
    }
  }

  // Funzioni per navigare il carosello
  const handlePrev = () => {
    setCurrentMediaIndex((prevIndex) =>
      prevIndex === 0 ? mediaItems.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentMediaIndex((prevIndex) =>
      prevIndex === mediaItems.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <>
      {/* Linguetta Sidebar (visibile quando chiusa) */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '-40px',
          transform: 'translateY(-50%)',
          zIndex: 100,
          display: isOpen ? 'none' : 'flex',
          alignItems: 'center',
          bgcolor: 'white',
          color: 'black',
          p: 1,
          pl: 0.5,
          pr: 0.5,
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
          boxShadow: 2,
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
          '&:hover': {
            bgcolor: 'grey.400',
          },
          marginRight: '-10px',
        }}
        onClick={toggleSidebar}
      >
        <IconButton size="small" sx={{ color: 'inherit' }}>
          <ArrowBackIosNewIcon sx={{ fontSize: '1rem' }} />
        </IconButton>
      </Box>

      {/* Pulsante di chiusura – visibile quando la sidebar è aperta */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '-385px',
          transform: 'translateY(-50%)',
          zIndex: 800,
          display: isOpen ? 'flex' : 'none',
          bgcolor: 'white',
          color: 'black',
          p: 1,
          pl: 0.5,
          pr: 0.5,
          boxShadow: 2,
          borderTopLeftRadius: 4,
          borderBottomLeftRadius: 4,
        }}
      >
        <IconButton color="inherit" onClick={toggleSidebar} size="small">
          <ArrowBackIosNewIcon sx={{ fontSize: '1rem', color: 'black' }} />
        </IconButton>
      </Box>

      {/* Sidebar vera e propria */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%', // posizionamento verticale al centro
          right: '100%', // il bordo destro della sidebar all'inizio del contenitore
          transform: isOpen
            ? 'translateX(0) translateY(-50%)'
            : 'translateX(-100%) translateY(-50%)',
          width: '300px',
          bgcolor: 'grey.200',
          p: 3,
          boxShadow: 3,
          zIndex: 950,
          // Se il contenuto dovesse essere lungo, puoi abilitare l'overflowY
          overflowY: 'auto',
          transition: 'transform 0.3s ease-in-out',
          display: isOpen ? 'block' : 'none',
        }}
      >
        <Paper
          elevation={1}
          sx={{
            p: 2,
            minWidth: '280px',
            // Centriamo il contenuto verticalmente
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography variant="h6" component="h3" sx={{ mb: 2, textAlign: 'center' }}>
            Media del Prodotto
          </Typography>

          {mediaItems.length > 0 ? (
            <>
              {/* Pulsante sinistro del carosello */}
              <IconButton
                onClick={handlePrev}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: 0,
                  transform: 'translateY(-50%)',
                  zIndex: 2,
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>

              {/* Contenuto del media corrente */}
              <Box sx={{ textAlign: 'center' }}>
                {mediaItems[currentMediaIndex].type === 'image' && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2">Immagine:</Typography>
                    <img
                      src={mediaItems[currentMediaIndex].content}
                      alt="Media prodotto"
                      style={{ width: '100%' }}
                    />
                  </Box>
                )}
                {mediaItems[currentMediaIndex].type === 'video' && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2">Video:</Typography>
                    <video width="100%" controls>
                      <source src={mediaItems[currentMediaIndex].content} type="video/mp4" />
                      Il tuo browser non supporta il video.
                    </video>
                  </Box>
                )}
                {mediaItems[currentMediaIndex].type === '3d' && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2">3D Viewer:</Typography>
                    <iframe
                      src={mediaItems[currentMediaIndex].content}
                      title="3D Viewer"
                      style={{ width: '100%', height: '300px', border: 'none' }}
                    />
                  </Box>
                )}
              </Box>

              {/* Pulsante destro del carosello */}
              <IconButton
                onClick={handleNext}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 0,
                  transform: 'translateY(-50%)',
                  zIndex: 2,
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </>
          ) : (
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              Nessun media disponibile per questo prodotto.
            </Typography>
          )}
        </Paper>
      </Box>
    </>
  );
};

export default ProductMediaSidebar;
